exports.MOCK_SERVER_URL = 'http://localhost:4001/memo';
exports.LOCAL_SERVER_URL = 'ttp://127.0.0.1:8000/';
exports.SERVER_URL = 'https://www.whaling-vote.kro.kr/';
